// extracted by mini-css-extract-plugin
module.exports = {"customInput":"index_customInput__2vgPy","wrapperRemove":"index_wrapperRemove__2IaUJ","removeIcon":"index_removeIcon__3cQLi","actionBtn":"index_actionBtn__fNMYg"};